import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import smoothscroll from 'smoothscroll-polyfill';
import smoothscrollAnchorPolyfill from 'smoothscroll-anchor-polyfill';
import { SWRConfig } from 'swr';

import IntroRouter from './routes/intro';
import HomeRouter from './routes/home';
import LegalRouter from './routes/legal';
import RandomChannelRouter from './routes/random-channel';
import StellaRouter from './routes/stella';
import WebtoonRouter from './routes/webtoon';
import SiteLayout from './routes/layout/SiteLayout';
import { LocaleProvider, useLocale } from './lib/context/locale-context';

function LocaleLayout({ locale }) {
  const { setCurrentLocale, options } = useLocale();

  useEffect(() => {
    const found = options.find((o) => o.value === locale);
    if (found) setCurrentLocale(found);
  }, [locale, options, setCurrentLocale]);

  return <Outlet />;
}

function App() {
  useEffect(() => {
    smoothscroll.polyfill();
    smoothscrollAnchorPolyfill.polyfill();
  }, []);

  const swrOptions = {
    fetcher: (url) =>
      fetch(url).then(async (response) => {
        if (response.status !== 200) {
          const error = new Error('An error occurred while fetching the data.');
          error.info = await response.json();
          error.status = response.status;
          throw error;
        }
        return response.json();
      }),
  };

  return (
    <LocaleProvider>
      <SWRConfig value={swrOptions}>
        <BrowserRouter>
          <Routes>
            {/* 한국어 (기본) 라우트 */}
            <Route element={<LocaleLayout locale="ko" />}>
              <Route path="/" element={<Navigate replace to="/intro" />} />
              <Route path="/intro/*" element={<IntroRouter />} />
              <Route element={<SiteLayout />}>
                <Route path="/home/*" element={<HomeRouter />} />
                <Route path="/legal/*" element={<LegalRouter />} />
                <Route path="/random-channel/*" element={<RandomChannelRouter />} />
                <Route path="/stella/*" element={<StellaRouter />} />
                <Route path="/webtoon/*" element={<WebtoonRouter />} />
              </Route>
            </Route>

            {/* 일본어 라우트 (/jp 접두사 유지) */}
            <Route path="/jp" element={<LocaleLayout locale="jp" />}>
              <Route index element={<Navigate replace to="intro" />} />
              <Route path="intro/*" element={<IntroRouter />} />
              <Route element={<SiteLayout />}>
                <Route path="home/*" element={<HomeRouter />} />
                <Route path="legal/*" element={<LegalRouter />} />
                <Route path="random-channel/*" element={<RandomChannelRouter />} />
                <Route path="stella/*" element={<StellaRouter />} />
                <Route path="webtoon/*" element={<WebtoonRouter />} />
              </Route>
            </Route>
          </Routes>
        </BrowserRouter>
      </SWRConfig>
    </LocaleProvider>
  );
}

export default App;
